import { suuid } from "@zetalabs/core";
import { SubjectHash } from "../hash";
import {
	FileDownload,
	FileUpload,
	ProcessingStatus,
	SessionType,
	TerminationStatus,
} from "../types";

export const FileMangerBuilder = {
	upload(file: File, subject: SubjectHash): FileUpload {
		return {
			id: suuid(),
			name: file.name,
			ext: file.name.split(".").pop() ?? "",
			type: SessionType.Upload,
			unifiedUri: null,
			sessionId: subject.id, // should be subject.value
			source: file,
			thumbnailSrc: null,
			status: TerminationStatus.Idle,
			progress: 0,
			error: null,
		};
	},
	download(uri: string, name: string, ext: string): FileDownload {
		return {
			id: uri,
			name,
			ext,
			type: SessionType.Download,
			source: null,
			unifiedUri: uri,
			progress: 0,
			error: null,
			status: ProcessingStatus.Preparing,
		};
	},
};
